import React, { useEffect, useMemo, useState } from 'react';
import { List, StatusTip } from 'tea-component';
import { getFeedsComments } from '@/pages/opinion/services/feeds';
import { useDebounceFn } from 'ahooks';
import ChatItem from '@/pages/opinion/components/Snippets/ChatItem';
import './index.scss';
import { feedsContentMap } from '@/pages/opinion/utils/languageValue';
import { LanguageType } from '../../types/common';
import NoDataCommon from '../NoDataCommon';
import { useIntl } from 'umi';

const pageSize = 20;
export default function TabPanelItem({
  language,
  itemClick,
  commonParams,
  count,
}: {
  itemClick: (value: any) => void;
  language: LanguageType;
  commonParams: any;
  count: number;
}) {
  const { formatMessage } = useIntl();
  const [chatList, setChatList] = useState<Array<any>>([]);
  const [total, setTotal] = useState(0);

  const [loading, setLoading] = useState(false);

  const [pageIndex, setPageIndex] = useState(1);

  const loadingFinish = useMemo(() => {
    return chatList?.length === total;
  }, [chatList, total]);

  const getExpandableChatList = (isFirst?: boolean) => {
    if (count === 0) return;
    // 加载完成了，就不继续加载了
    if ((loadingFinish && !isFirst) || loading) return;

    setLoading(true);
    getFeedsComments({
      ...commonParams,
      page: pageIndex,
      page_size: pageSize,
    })
      .then((resultData: any) => {
        const { total, list } = resultData || {};
        let chatListResult = chatList.concat(list || []);
        let pageIndexResult = pageIndex + 1;
        let totalResult = total;

        setChatList(chatListResult);
        setTotal(totalResult);
        setPageIndex(pageIndexResult);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getExpandableChatList(true);
  }, [count]);

  const { run } = useDebounceFn(getExpandableChatList);
  return (
    <List
      className="dbo-tablechat-context list-box"
      onScrollBottom={() => run()}
    >
      {count > 0 && (
        <div className="list-header-tips">
          {formatMessage({
            id: 'The following reviews are sorted by engagements',
          })}
        </div>
      )}
      {chatList?.map((item) => (
        <ChatItem
          key={item.comment_uin + item.content}
          className="list-item dbo-context-component-flex"
          item={item}
          itemClick={() => itemClick(item)}
          theme="white"
          language={language}
          languageMap={feedsContentMap}
          iconStyle={{ width: 20, height: 20 }}
        ></ChatItem>
      ))}
      <List.Item style={{ minHeight: 60 }}>
        {loading ? (
          <StatusTip className="tips" status="loading" />
        ) : total === 0 ? (
          <NoDataCommon
            style={{ height: 400 }}
            hasTitle
            hasImg
            hasDesc
          ></NoDataCommon>
        ) : // <EmptyTip
        //   className="tips big"
        //   emptyText={<div>{NO_DATE.SELECTION}</div>}
        // />
        null}
      </List.Item>
    </List>
  );
}
